<template>
  <v-row justify="center" >
    <v-dialog v-model="showTable" persistent max-width="60%">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col class="text-end px-0 py-0" cols="12">
              <v-btn icon dark @click="wip()">
                <v-icon color="primary">mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-center py-0" cols="12">
              <h1 class="mb-0 mt-0" style="font-size:22px;">Nota fiscal</h1>
              <p v-if="formData.id == null" class="mb-0" style="font-size:14px;">Informe o dados de nota fiscal associada ao(s) lote(s).</p>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pb-1">
          <v-row>
            <v-col class="card-form" cols="12">
              <CadastroForm
                :formData="formData"
                :notaFiscalFormValid="notaFiscalFormValid"
                :obrigatorio="obrigatorio"
                :sendFile="(file) => addFile(file)"
                :validateForm="validateForm"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="card-form pb-4 pt-3" >
          <v-row class="px-8 px-xs-1 my-0">
              <v-btn
                color="primary"
                depressed
                height="30px"
                small
                outlined
                @click="wip()"
              >
                Cancelar
              </v-btn>
            <v-spacer></v-spacer>
              <v-btn
                color="primary"
                depressed
                height="30px"
                small
                @click="save(formData)"
              > Salvar
              </v-btn>
          </v-row>
    </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CadastroForm from "./CadastroForm"
export default {
  components: {
    CadastroForm,
  },
  data() {
    return {
      file: null,
      showTable: false,
      formData: {
          id: null,
          numero: null,
          dt_emissao: null,
          valor: 0.00,
          link: null,
          anexo: null,
          dt_alteracao: null
      },
      validateForm: false,
      notaFiscalFormValid: {isValid: true}
    };
  },
  methods: {
    addFile(file) {
      this.file = file
    },
    wip() {
      this.formData = {
        id: null,
        numero: null,
        dt_emissao: null,
        valor: 0.00,
        link: null,
        anexo: null
      }
      this.showClose(false)
    },
    initForm() {
      this.formData = {
        id: null,
        numero: null,
        dt_emissao: null,
        valor: 0.00,
        link: null,
        anexo: null
      }
    },
    save(formData) {
     this.validateForm = true
     this.$nextTick(()=> {
       if(!this.notaFiscalFormValid){
         this.validateForm = false
         return
       }
        if (formData.id == null) {
          let opts = {
            numero: formData.numero,
            dt_emissao: formData.dt_emissao,
            valor: formData.valor,
            link: formData.link,
            dt_alteracao: formData.dt_alteracao
          }
          this.sendForm(opts, this.file)
          this.formData = {}
        } else {
          this.associados(this.formData)
        }
        this.validateForm = false
     })
    },
    associados(val) {
      let select = []
      let lotes = val.lotes
      // select = lotes.filter(el=> el.associada).map(el => el.id) 
      select = lotes.reduce((arr, item) => {
          let associadas = item.associada == null ? false :true
          let id = item.id
          let dtAlteracao = item.dt_alteracao
          let obj = {lote_id: id, associada: associadas, dt_alteracao: dtAlteracao}
          if (item) {
              arr.push(obj)
          }
          return arr
      },[])
      let opts = {
        id: val.id,
        numero: val? val.numero: null,
        dt_emissao: val.dt_emissao,
        valor: val.valor,
        link: val.link,
        associaLote: select,
        dt_alteracao: val.dt_alteracao
      }
      this.sendForm(opts, this.file)
      this.formData = {}
    }
  },
  watch: {
    showOpen(val) {
      this.showTable = val
      if (val && !this.notaFiscal.id) {
        this.initForm()
        this.validateForm = false
      } 
      // else {
      //   this.formData = this.notaFiscal
      // }
   },
    notaFiscal(val) {
      this.formData = val
    },
  },
  props: {
    notaFiscal: Object,
    showOpen: Boolean,
    showClose: Function,
    sendForm: Function,
    obrigatorio: Array,
  },
};
</script>

<style scoped>
.card-form {
  padding: 0 130px;
}
@media (max-width: 969px) {
  .card-form {
    padding: 0;
  }
}
</style>